import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AudienceIntro } from './components/AudienceIntro';
import { NoExperience } from './components/NoExperience';
import { Problem } from './components/Problem';
import { Agitation } from './components/Agitation';
import { Solution } from './components/Solution';
import { Modules } from './components/Modules';
import { Bonus } from './components/Bonus';
import { TargetAudience } from './components/TargetAudience';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { initPixel } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <AudienceIntro data-id="element-4" />
        <NoExperience data-id="element-5" />
        <Problem data-id="element-6" />
        <Agitation data-id="element-7" />
        <Solution data-id="element-8" />
        <Modules data-id="element-9" />
        <Bonus data-id="element-10" />
        <TargetAudience data-id="element-11" />
        <Pricing data-id="element-12" />
        <Guarantee data-id="element-13" />
        <FAQ data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
      <StickyMobileCTA data-id="element-17" />
    </div>;
}